import React from "react";
import { motion } from "framer-motion";
import { MdDeleteOutline, MdFormatQuote } from "react-icons/md";
import RatingStars from "../ui/RatingStars";
import StatusBadge from "../ui/StatusBadge";

const TestimonialCard = ({
  item,
  mode = "public",
  isAdminLoggedIn = false,
  onApprove,
  onReject,
  onEdit,
  onDelete,
}) => {
  const isAdmin = mode === "admin";
  const showAdminActions = isAdmin && isAdminLoggedIn;

  return (
    <motion.article
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      whileHover={{ y: -4 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.28 }}
      className={`group relative ${isAdmin ? "" : "h-full"} overflow-hidden rounded-[1.75rem] border border-maroon/10 bg-gradient-to-br from-white via-cream/40 to-white p-6 shadow-[0_14px_45px_rgba(44,23,31,0.08)] backdrop-blur-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_22px_70px_rgba(44,23,31,0.14)]`}
    >
      <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-maroon/10 blur-2xl" />
      <div className="absolute bottom-0 left-0 h-24 w-24 rounded-full bg-sky-200/30 blur-3xl" />

      <div className="relative z-10">
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-center gap-3">
            <img
              src={item.photo}
              alt={item.fullName}
              className="h-14 w-14 rounded-full border-2 border-white object-cover shadow-[0_10px_24px_rgba(15,23,42,0.12)] ring-1 ring-maroon/10"
            />
            <div>
              <h3 className="text-[1rem] font-semibold tracking-tight text-maroon">
                {item.fullName}
              </h3>
              <p className="mt-1 text-xs leading-5 text-slate-500">
                {item.company || "Individual Client"}
                {item.city ? ` • ${item.city}` : ""}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2">
            {isAdmin ? <StatusBadge status={item.status} /> : null}
            <span className="rounded-full bg-maroon/10 p-2 text-maroon/70 shadow-sm">
              <MdFormatQuote className="text-xl" />
            </span>
          </div>
        </div>

        <div className="mt-4">
          <RatingStars value={item.rating} readonly />
        </div>

        <p className={`testimonial-description mt-4 ${isAdmin ? "" : "h-44 overflow-y-auto"} break-words rounded-2xl border border-maroon/10 bg-white/80 px-4 py-4 text-sm leading-7 text-slate-700 shadow-[inset_0_1px_0_rgba(255,255,255,0.75)]`}>
          {item.message}
        </p>

        {showAdminActions ? (
          <div className="mt-4">
            <p className="text-xs text-slate-500">{item.email}</p>
            <p className="mt-1 text-xs text-slate-500">
              Submitted: {new Date(item.createdAt).toLocaleDateString()}
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              <button
                type="button"
                onClick={() => onApprove && onApprove(item.id)}
                className="rounded-full border border-emerald-200 bg-emerald-50 px-3.5 py-1.5 text-xs font-semibold text-emerald-700 transition hover:border-emerald-300 hover:bg-emerald-100"
              >
                Approve
              </button>
              <button
                type="button"
                onClick={() => onEdit && onEdit(item)}
                className="rounded-full border border-sky-200 bg-sky-50 px-3.5 py-1.5 text-xs font-semibold text-sky-700 transition hover:border-sky-300 hover:bg-sky-100"
              >
                Edit
              </button>
              <button
                type="button"
                onClick={() => onReject && onReject(item.id)}
                className="rounded-full border border-rose-200 bg-rose-50 px-3.5 py-1.5 text-xs font-semibold text-rose-700 transition hover:border-rose-300 hover:bg-rose-100"
              >
                Reject
              </button>
              <button
                type="button"
                onClick={() => onDelete && onDelete(item.id)}
                className="inline-flex items-center gap-1 rounded-full border border-slate-200 bg-white px-3.5 py-1.5 text-xs font-semibold text-slate-700 transition hover:border-slate-300 hover:bg-slate-50"
              >
                <MdDeleteOutline className="text-sm" />
                Delete
              </button>
            </div>
          </div>
        ) : null}
      </div>
    </motion.article>
  );
};

export default TestimonialCard;
